import React, { Component } from "react";
import PropTypes from "prop-types";
import { OtpV2 } from "arv-extends";
import { CIRCLE_PROGRAM } from "npmlinks-constants";

class CircleOtp extends Component {
  constructor() {
    super();
    this.state = {
      generateOtpReqBody: {},
      validateOtpReq: {},
    };
    this.afterValidationCallBack = this.afterValidationCallBack.bind(this);
    this.afterGenerateOtpCallBack = this.afterGenerateOtpCallBack.bind(this);
  }

  componentDidMount() {
    this.setState({
      generateOtpReqBody: {
        mobileNumber: this.props.mobileNumber,
      },
    });
  }

  afterGenerateOtpCallBack(generateOtpResponse) {
    const { mobileNumber } = this.props;
    const { state, sessionID } = generateOtpResponse;
    const unverifyMobileNo = true;
    if (generateOtpResponse) {
      this.setState({
        validateOtpReq: {
          mobileNumber,
          state,
          sessionID,
          unverifyMobileNo,
        },
      });
    }
  }

  afterValidationCallBack = otpValidateInfo => {
    if (otpValidateInfo && otpValidateInfo.data) {
      this.props.otpVerified();
      console.log("Otp Verified");
    }
  };

  render() {
    return (
      <div>
        <div className="wc-circleotp-heading">
          {CIRCLE_PROGRAM.CIRCLE_OTP_HEADING}
        </div>
        <OtpV2.component
          generateOtpReqBody={this.state.generateOtpReqBody}
          validateOtpReq={this.state.validateOtpReq}
          otpHeading=""
          otpSubHeading={CIRCLE_PROGRAM.CIRCLE_OTP_SUBHEADING}
          afterGenerateOtpCallBack={this.afterGenerateOtpCallBack}
          afterValidationCallBack={this.afterValidationCallBack}
        />
      </div>
    );
  }
}

CircleOtp.propTypes = {
  mobileNumber: PropTypes.string.isRequired,
  otpVerified: PropTypes.func.isRequired,
};

export default CircleOtp;
